exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".calendar-link[data-v-4225e132]{text-transform:uppercase;color:#09f;font-size:12px;text-decoration:none;font-weight:700;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4225e132","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/calendar/link/component.vue
// module id = 3416dbd6d0fbaa7ad2fc
// module chunks = 13